import { useContext } from "react";

import Breadcrumb from "antd/lib/breadcrumb";
import { AppContext } from "App";
import { PiCaretLeftBold, PiCaretRightBold } from "react-icons/pi";
import { Link } from "react-router-dom";
import "../../../styles/navigation.less";

interface NavigationProps {
    items: { title: string, url: string }[]
    handleBack?: () => void
}

interface BreadcrumbProps {
    items: { title: string, url: string }[]
}

interface BackButtonProps {
    title?: string,
    url?: string
    backUrl?: string
    handleBack?: () => void
}

const BreadcrumbNavigation = ({ items }: BreadcrumbProps) => {
    return (
        <div className='horizontal-center'>
            <Breadcrumb
                className="breadcrumb-wrapper"
                items={items.map(item => {
                    return { title: <Link to={item.url}>{item.title}</Link> };
                })}
                separator={
                    <div className="breadcrumb-separator">
                        <PiCaretRightBold fontSize={"22px"} />
                    </div>
                }
            />
        </div>
    );
};

const BackButtonNavigation = ({
    title,
    url,
    backUrl,
    handleBack,
}: BackButtonProps) => {
    const isLink = !handleBack;

    return (
        <div className='horizontal-center'>
            <div className="back-nav-wrapper">
                {isLink ? (
                    <Link to={backUrl ?? "/"} className="back-nav-icon">
                        <PiCaretLeftBold fontSize={"22px"} />
                    </Link>
                ) : (
                    <div onClick={handleBack} className="back-nav-icon">
                        <PiCaretLeftBold fontSize={"22px"} />
                    </div>
                )}

                {isLink ? (
                    <Link to={url ?? "/"} className="back-nav-link">
                        {title}
                    </Link>
                ) : (
                    <div
                        onClick={handleBack}
                        className="back-nav-link"
                    >
                        {title}
                    </div>
                )}
            </div>
        </div>
    );
};

const Navigation = ({ items, handleBack }: NavigationProps) => {
    const { isMobile } = useContext(AppContext);

    const previousPage = items[items.length - 2];
    const currentPage = items[items.length - 1];

    return <div className={isMobile ? "navigation__header-wrapper" : ""}>
        <div style={{ marginTop: isMobile ? "0px" : "120px" }}>
            {isMobile ? (
                <BackButtonNavigation
                    title={currentPage.title}
                    url={currentPage.url}
                    backUrl={previousPage.url}
                    handleBack={handleBack}
                />
            ) : (
                <BreadcrumbNavigation items={items}/>
            )}
        </div>
    </div>;
};

export default Navigation;
